"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapBosApiToNextCustomerTypeString = exports.mapBosApiToNextCustomerType = void 0;
const enums_1 = require("../../enums");
const mapBosApiToNextCustomerType = (type, toString = false) => {
    switch (type) {
        case enums_1.BosCustomerType.BUSINESS:
            return enums_1.CustomerType.BUSINESS;
        case enums_1.BosCustomerType.PRIVATE:
        default:
            return enums_1.CustomerType.PRIVATE;
    }
};
exports.mapBosApiToNextCustomerType = mapBosApiToNextCustomerType;
const mapBosApiToNextCustomerTypeString = (type) => enums_1.CustomerType[(0, exports.mapBosApiToNextCustomerType)(type)];
exports.mapBosApiToNextCustomerTypeString = mapBosApiToNextCustomerTypeString;
//# sourceMappingURL=bos-api.js.map